import { isAuthenticated } from "../../utils/identityUtils";
import { getSegmentIds } from "../../utils/getSegmentIds";
import { getCountryEndpoint } from "../../helpers";

export const FETCH_SUBSCRIPTION_PLANS = "FETCH_SUBSCRIPTION_PLANS";
export const RECEIVE_SUBSCRIPTION_PLANS = "RECEIVE_SUBSCRIPTION_PLANS";
export const SUBSCRIPTION_PLANS_ERROR = "SUBSCRIPTION_PLANS_ERROR";

export function fetchSubscriptionPlansStart() {
  return { type: FETCH_SUBSCRIPTION_PLANS };
}

export function receiveSubscriptionPlans(plans) {
  return { type: RECEIVE_SUBSCRIPTION_PLANS, plans };
}

export function subscriptionPlansError(error) {
  return { type: SUBSCRIPTION_PLANS_ERROR, error };
}

const getSegmentsHeader = async (additionalHeaders) => {
  const response = await getSegmentIds();
  if (Array.isArray(response) && response.length > 0) {
    const segmentIds = response.map((segment) => segment.segmentId).join(",");
    additionalHeaders["asos-c-segmentids"] = segmentIds;
  }
  return additionalHeaders;
};

// Fetch the selected country's Premier plans (segment-aware; response varies by
// URL params and the customer's audience segments, so no caching is assumed).
export function fetchSubscriptionPlans(country, currency, language) {
  return async (dispatch) => {
    dispatch(fetchSubscriptionPlansStart());

    let additionalHeaders = {};
    const isLoggedIn = await isAuthenticated();
    if (isLoggedIn) {
      try {
        additionalHeaders = await getSegmentsHeader(additionalHeaders);
      } catch (e) {
        // Segment IDs are an enhancement for the request, not a precondition;
        // if resolving them fails, continue fetching plans without them.
      }
    }

    return fetch(getCountryEndpoint(country, currency, language, isLoggedIn), {
      headers: additionalHeaders,
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        return dispatch(
          subscriptionPlansError(response.message || "Service Error")
        );
      })
      .then((data) => {
        if (!data || !Array.isArray(data.subscriptionOptions)) {
          return dispatch(subscriptionPlansError("Service Error"));
        }
        return dispatch(receiveSubscriptionPlans(data.subscriptionOptions));
      })
      .catch((err) => dispatch(subscriptionPlansError(err.message)));
  };
}
